import React from "react";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";

const Services = () => {
  const services = [
    {
      title: "Instalación de Canaletas",
      description:
        "Realizamos instalaciones con materiales duraderos y de calidad.",
      img: "servicios1.png",
    },
    {
      title: "Fabricación a Medida",
      description:
        "Diseños personalizados para satisfacer todas sus necesidades.",
      img: "servicios2.png",
    },
    {
      title: "Reparación de Techos",
      description:
        "Soluciones rápidas y efectivas para cualquier tipo de techo.",
      img: "servicios3.png",
    },
  ];

  return (
    <Container id="services" style={{ padding: "80px 0" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Nuestros Servicios
      </Typography>
      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <Card
              style={{
                transition: "transform 0.3s",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <CardMedia
                component="img"
                alt={service.title}
                height="140"
                image={service.img}
              />
              <CardContent>
                <Typography variant="h5">{service.title}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Services;
